exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".article .item {\n  padding: 16px; }\n\n.article .header {\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-bottom: 16px; }\n  .article .header .back-btn {\n    -ms-flex-item-align: center;\n    align-self: center; }\n    .article .header .back-btn:hover {\n      cursor: pointer; }\n  .article .header h1.title {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 1.5rem;\n    line-height: 1;\n    color: #000000;\n    -ms-flex-item-align: center;\n    align-self: center;\n    font-weight: 400; }\n\n.article > div:nth-child(2) {\n  max-height: calc(100vh - 150px);\n  overflow: auto; }\n\n@media only screen and (max-width: 600px) {\n  .article {\n    margin-left: 10px;\n    margin-right: 10px;\n    width: calc(100vw - 20px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/menu/article/Article.scss
// module id = 1666
// module chunks = 0